module.exports = __webpack_public_path__ + "img/settings.d5248647.svg";